import { render } from "./EditorLoader.vue?vue&type=template&id=2559e24e&scoped=true"
import script from "./EditorLoader.vue?vue&type=script&lang=js"
export * from "./EditorLoader.vue?vue&type=script&lang=js"

import "./EditorLoader.vue?vue&type=style&index=0&id=2559e24e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2559e24e"]])

export default __exports__